'use client';

import a__default, { memo, forwardRef } from "react";
import { classNames } from "../../utils/styles/classNames.js";
import { Text } from "../Text/Text.js";
import { containerSize, container, spin } from "./LoadingSpinner.css.js";
import { sizeValues } from "./utils/sizes.js";
import { defaultProps } from "./LoadingSpinner.defaultProps.js";
function LoadingSpinnerComponent({
  onDark,
  a11yLabel: a11yLabelProp,
  a11yHidden,
  size: sizeProp,
  dataQa,
  ...rest
}, ref) {
  const a11yLabel = a11yLabelProp || defaultProps.a11yLabel;
  const size = sizeProp || defaultProps.size;
  const sizeValue = sizeValues[size];
  const spinnerSVG = /* @__PURE__ */ a__default.createElement(
    "svg",
    {
      "aria-hidden": "true",
      className: spin,
      focusable: "false",
      height: sizeValue,
      viewBox: "0 0, 100 100",
      width: sizeValue,
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ a__default.createElement("defs", null, /* @__PURE__ */ a__default.createElement(
      "linearGradient",
      {
        gradientTransform: "rotate(10)",
        id: "linear",
        x1: "0%",
        x2: "100%",
        y1: "0%",
        y2: "0%"
      },
      /* @__PURE__ */ a__default.createElement("stop", { offset: "10%", stopColor: onDark ? "#FFF" : "#1A1A1A" }),
      /* @__PURE__ */ a__default.createElement("stop", { offset: "100%", stopColor: onDark ? "#FFF0" : "#1A1A1A00" })
    )),
    /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M 50 10 A 40 40 0 1 0 90 50",
        fill: "none",
        stroke: "url(#linear)",
        strokeLinecap: "round",
        strokeWidth: "10"
      }
    )
  );
  return /* @__PURE__ */ a__default.createElement(
    "span",
    {
      className: classNames(container, containerSize[size]),
      "data-qa": dataQa,
      ref,
      ...rest
    },
    spinnerSVG,
    !a11yHidden && /* @__PURE__ */ a__default.createElement(Text, { visuallyHidden: true }, a11yLabel)
  );
}
const LoadingSpinner = /* @__PURE__ */ memo(
  forwardRef(LoadingSpinnerComponent)
);
export {
  LoadingSpinner
};
